wbApp.filter('formAccessPermissionsType', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_FROM_ACCESS_PERMISSION_TYPE_LOGGED_IN_USERS_ONLY_STUDENT_REQUIRED');
            case 1:
                return $translate.instant('TXT_FROM_ACCESS_PERMISSION_TYPE_ALLOW_ANONYMOUS_NO_STUDENT');
            case 2:
                return $translate.instant('TXT_FROM_ACCESS_PERMISSION_TYPE_ALLOW_ANONYMOUS_STUDENT_REQUIRED');
            case 3:
                return $translate.instant('TXT_FROM_ACCESS_PERMISSION_TYPE_LOGGED_IN_USERS_ONLY_NO_STUDENT');
            default:
                return '';
        }
    };
}]);